import {CHAT_MAXIMUM_CHARACTER_LIMIT, LobbyImage} from '@colonist/types'
import {clientI18n} from '../../ClientI18n'
import {createDivIn, createFormIn, createImgIn, createInputIn} from '../../ui_utils/DomUtils'
import {UIGameFeed} from './UIGameFeed'

export class UIGameChatView extends UIGameFeed {
    formElement: HTMLFormElement
    inputElement: HTMLInputElement
    buttonElement: HTMLDivElement

    constructor(isChatEnabled: boolean) {
        super('game-chat-text', 'game-chat-block')
        this.createInputElement(this.mainBlock)
        if(isChatEnabled == false) this.hideChat()
    }

    private createInputElement(topContainer: HTMLDivElement) {
        this.formElement = createFormIn(topContainer, 'game-chat-form', 'game-chat-form')

        this.inputElement = createInputIn(this.formElement, 'form-control', 'game-chat-input')
        this.inputElement.type = 'text'
        this.inputElement.autocomplete = 'off'
        this.inputElement.placeholder = clientI18n.t('strings:homePage.header.sendMessage')
        this.inputElement.maxLength = CHAT_MAXIMUM_CHARACTER_LIMIT

        this.buttonElement = createDivIn(this.formElement, 'form-chat-send-button')
        createImgIn(this.buttonElement, LobbyImage.SendArrow)
    }

    setMargin(margin: number) {
        this.mainBlock.style.marginTop = margin + 'px'
    }

    setFormWidth(width: number) {
        this.formElement.style.width = width + 'px'
    }

    hideChat() {
        this.container.style.display = 'none'
        this.mainBlock.style.display = 'none'
    }

    showChat() {
        this.container.style.display = 'block'
        this.mainBlock.style.display = 'block'
    }
}
